webpackJsonp([180372703912199],{

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/final.13ba4c3e.png";

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(196);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 1: Add Create Button'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to add a button to our application that will launch a dialog when the user clicks on it.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'dialogs.1' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add Create Button'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Run this command to generate our ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'CreateButton'
	      ),
	      ' component:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generate component CreateButton\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then modify the component to look like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n\n        export default createReactClass({\n          displayName: \'CreateButton\',\n\n          onClick() {\n            console.log(\'Create tweet!\');\n          },\n\n          render() {\n            return (\n              <button\n                type="button"\n                className="btn btn-primary btn-lg create-button"\n                onClick={this.onClick}>\n                +\n              </button>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class CreateButton extends React.Component {\n\n          constructor(props) {\n            super(props);\n            this.onClick = this.onClick.bind(this);\n          }\n\n          onClick() {\n            console.log(\'Create tweet!\');\n          }\n\n          render () {\n            return (\n              <button\n                type="button"\n                className="btn btn-primary btn-lg create-button"\n                onClick={this.onClick}>\n                +\n              </button>\n            );\n          }\n\n        }\n\n        export default CreateButton;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class CreateButton extends React.Component {\n\n          constructor(props) {\n            super(props);\n            this.onClick = this.onClick.bind(this);\n          }\n\n          onClick() {\n            console.log(\'Create tweet!\');\n          }\n\n          render () {\n            return (\n              <button\n                type="button"\n                className="btn btn-primary btn-lg create-button"\n                onClick={this.onClick}>\n                +\n              </button>\n            );\n          }\n\n        }\n\n        export default CreateButton;\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Eventually, we\'ll have this component launch a dialog when the user clicks on it, but for now we\'ll just have it write a log to the console to say the button was clicked.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add Button to Header'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Header'
	      ),
	      ' component. Then import the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'CreateButton'
	      ),
	      ' component and insert it into the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        // src/components/Header.js\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n        import CreateButton from \'./CreateButton\';\n\n        export default createReactClass({\n          displayName: \'Header\',\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <Link className="navbar-brand" to="/">\n                      Lore Quickstart\n                    </Link>\n                  </div>\n                  <CreateButton/>\n                </div>\n              </nav>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        // src/components/Header.js\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n        import CreateButton from \'./CreateButton\';\n\n        class Header extends React.Component {\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <Link className="navbar-brand" to="/">\n                      Lore Quickstart\n                    </Link>\n                  </div>\n                  <CreateButton/>\n                </div>\n              </nav>\n            );\n          }\n\n        }\n\n        export default Header;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        // src/components/Header.js\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n        import CreateButton from \'./CreateButton\';\n\n        class Header extends React.Component {\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <Link className="navbar-brand" to="/">\n                      Lore Quickstart\n                    </Link>\n                  </div>\n                  <CreateButton/>\n                </div>\n              </nav>\n            );\n          }\n\n        }\n\n        export default Header;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/CreateButton.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n\n        export default createReactClass({\n          displayName: \'CreateButton\',\n\n          onClick() {\n            console.log(\'Create tweet!\');\n          },\n\n          render() {\n            return (\n              <button\n                type="button"\n                className="btn btn-primary btn-lg create-button"\n                onClick={this.onClick}>\n                +\n              </button>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class CreateButton extends React.Component {\n\n          constructor(props) {\n            super(props);\n            this.onClick = this.onClick.bind(this);\n          }\n\n          onClick() {\n            console.log(\'Create tweet!\');\n          }\n\n          render () {\n            return (\n              <button\n                type="button"\n                className="btn btn-primary btn-lg create-button"\n                onClick={this.onClick}>\n                +\n              </button>\n            );\n          }\n\n        }\n\n        export default CreateButton;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class CreateButton extends React.Component {\n\n          constructor(props) {\n            super(props);\n            this.onClick = this.onClick.bind(this);\n          }\n\n          onClick() {\n            console.log(\'Create tweet!\');\n          }\n\n          render () {\n            return (\n              <button\n                type="button"\n                className="btn btn-primary btn-lg create-button"\n                onClick={this.onClick}>\n                +\n              </button>\n            );\n          }\n\n        }\n\n        export default CreateButton;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Header.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n        import CreateButton from \'./CreateButton\';\n\n        export default createReactClass({\n          displayName: \'Header\',\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <Link className="navbar-brand" to="/">\n                      Lore Quickstart\n                    </Link>\n                  </div>\n                  <CreateButton/>\n                </div>\n              </nav>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n        import CreateButton from \'./CreateButton\';\n\n        class Header extends React.Component {\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <Link className="navbar-brand" to="/">\n                      Lore Quickstart\n                    </Link>\n                  </div>\n                  <CreateButton/>\n                </div>\n              </nav>\n            );\n          }\n\n        }\n\n        export default Header;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n        import CreateButton from \'./CreateButton\';\n\n        class Header extends React.Component {\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <Link className="navbar-brand" to="/">\n                      Lore Quickstart\n                    </Link>\n                  </div>\n                  <CreateButton/>\n                </div>\n              </nav>\n            );\n          }\n\n        }\n\n        export default Header;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-2/' },
	        'learn how to mount dialogs'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-dialogs-step-1-js-5bf55881f34de694ac04.js